/**
 * @packageDocumentation
 * @module f1/is
 */

/**
 * @param value a numerical value
 */
export type IsBetweenValue = (value: number) => boolean;

export interface IsBetween {
  /**
   * Is the value between two values (inclusive)
   *
   * @public
   * @function f1.is.between
   * @param min the lower bound (inclusive)
   * @param max the upper bound (inclusive)
   * @param value a numerical value
   * @example
   *
   * ```ts
   * f1.is.between(0, 1, 1) => true
   * f1.is.between(0, 1, 2) => false
   * ```
   */
  (min: number, max: number, v: number): boolean;
  /**
   * @param min the lower bound (inclusive)
   * @param max the upper bound (inclusive)
   */
  (min: number, max: number): IsBetweenValue;
}

/**
 * @see IsBetween
 */
export default (min: number, max: number, v: number) => {
  return min <= v && v <= max;
};
